import React from 'react';
import AddEmployeesPresentational from './add-employees-presentational';

const AddEmployeesFunctional = () => {
	return <AddEmployeesPresentational />;
};

export default AddEmployeesFunctional;
